import FormCreator from '../../../components/shared/FormCreator/formCreator';

import { addMedicationComponentProps } from './types';

const MedicationComponent = ({
  initialValues,
  isModalOpen,
  formFieldData,
  setIsModalOpen,
  handleSave,
  validationSchema,
}: addMedicationComponentProps) => {
  return (
    <FormCreator
      initialValues={initialValues}
      isModalOpen={isModalOpen}
      formFieldData={formFieldData}
      setIsModalOpen={setIsModalOpen}
      handleSave={handleSave}
      validationSchema={validationSchema}
    />
  );
};

export default MedicationComponent;
